import { LoaderFunctionArgs } from 'react-router'
import { getGetContractQueryOptions } from '@/api/generated/get-contract-controller/get-contract-controller'
import { queryClient } from '@/contexts/queryClient'

export const contractDetailsLayoutLoader = async ({ params }: LoaderFunctionArgs): Promise<void> => {
  await queryClient.fetchQuery(
    getGetContractQueryOptions(params.contractNumber!, {
      query: {
        staleTime: 0
      }
    })
  )
}
